import { BooleanField } from '@src/permitField/PermitFields';
import * as TripInformationPermitField from '@src/permitField/TripInformationFields';

export class TripOriginalOriginField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.TripOriginalOriginField.fieldName;
}

export class TripFinalDestinationField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.TripFinalDestinationField.fieldName;
}

export class TripOriginField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.TripOriginField.fieldName;
}

export class TripDestinationField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.TripDestinationField.fieldName;
}

export class TripBaseRegisteredWeightField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.TripBaseRegisteredWeightField.fieldName;
}

export class TripRouteField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.TripRouteField.fieldName;
}

export class TripMileageField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.TripMileageField.fieldName;
}

export class TripIncludesReturnTripField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.TripIncludesReturnTripField.fieldName;
}

export class TripReturnDestinationField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.TripReturnDestinationField.fieldName;
}

export class TripReturnRouteField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.TripReturnRouteField.fieldName;
}

export class TripReturnMileageField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.TripReturnMileageField.fieldName;
}

export class TripEffectiveDateField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.EffectiveDateField.fieldName;
}

export class TripEffectiveTimeField extends BooleanField {
  public static fieldName: string =
    TripInformationPermitField.EffectiveDateTimeField.fieldName;
}
